@if (!dataConnectionError && status === 'loaded') {
    @if (colDefs$ | ngrxPush; as colDefs) {
        <ag-grid-angular
            wdxUtilsAgGridTheme
            [rowData]="rowData"
            [columnDefs]="colDefs$ | ngrxPush"
            [gridOptions]="gridOptions"
            class="w-100"
            data-cy="standing-orders-table"
        >
        </ag-grid-angular>
    }
} @else {
    <wdx-portfolio-not-loaded
        [status]="dataConnectionError ? 'dataConnectionError' : status"
        [connectionErrorMessage]="dataConnectionError?.detail ?? ''"
        [dataTypeLabel]="dataTypeLabel"
    ></wdx-portfolio-not-loaded>
}
